import script from "./swiper-app.vue?vue&type=script&setup=true&lang=js"
export * from "./swiper-app.vue?vue&type=script&setup=true&lang=js"

import "./swiper-app.vue?vue&type=style&index=0&id=5ee92fd7&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ee92fd7"]])

export default __exports__